import { render, staticRenderFns } from "./NoHistoryPlaceholder.vue?vue&type=template&id=21913a2e&scoped=true&"
import script from "./NoHistoryPlaceholder.vue?vue&type=script&lang=js&"
export * from "./NoHistoryPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./NoHistoryPlaceholder.vue?vue&type=style&index=0&id=21913a2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21913a2e",
  null
  
)

export default component.exports